import type {
	ForgeExtensions,
	UiModificationsConfigs,
} from '../../../../../../../common/types/apps';
import type { AppToRenderResult } from '../../types';

import { normalizeExtensions } from './normalize-extensions';

const STABLE_EMPTY_ARRAY: AppToRenderResult[] = [];

export const getConfiguredApps = (
	forgeExtensions: ForgeExtensions | undefined,
	uiModificationsConfigs: UiModificationsConfigs | undefined,
): AppToRenderResult[] => {
	if (!forgeExtensions || !uiModificationsConfigs) {
		return STABLE_EMPTY_ARRAY;
	}

	// Put modules in the HashMap for a fast search & get by appEnvId
	const modulesHashMap = normalizeExtensions(forgeExtensions);

	return uiModificationsConfigs
		.filter((configuration) => !!modulesHashMap[configuration.appEnvId])
		.map((configuration) => ({
			forgeExtension: modulesHashMap[configuration.appEnvId],
			uiModificationsConfig: configuration.uiModifications.map(({ id, data }) => ({ id, data })),
		}));
};
